import _ from 'lodash';
class SandboxPoster {
    /**
     * 监听
     */
    private readonly listeners: { [key in SandboxPosterEvent]?: SandboxPosterListener<any>[] } = {};

    private readonly OnInitedPost: { [key in SandboxPosterEvent]?: any } = {};

    constructor() {
        console.warn('Init sandbox poster');
    }

    /**
     * 注册一个事件，外部使用的
     * @param type 事件类型
     * @param listener 监听
     */
    public On<T>(type: SandboxPosterEvent, listener: SandboxPosterListener<T>): () => void {
        const list = this.listeners[type] ? this.listeners[type] : [];
        list?.push(listener);
        this.listeners[type] = list;
        // 检查是否存在未处理数据
        if (this.OnInitedPost[type]) {
            listener(this.OnInitedPost[type]);
            delete this.OnInitedPost[type];
        }
        return () => _.remove(this.listeners[type] as any[], (o) => o == listener).length;
    }

    /**
     * 注销一个事件
     * @param type 事件类型
     * @param listener 监听
     * @returns true 删除，false 未找到
     */
    public Off<T>(type: SandboxPosterEvent, listener: SandboxPosterListener<T>): boolean {
        const list = this.listeners[type];
        if (!_.isArray(list)) {
            return false;
        }
        return _.remove(list, (o) => o == listener).length > 0;
    }

    public OffAll(type: SandboxPosterEvent): boolean {
        const list = this.listeners[type];
        if (!_.isArray(list)) {
            return false;
        }
        delete this.listeners[type];
        return true;
    }

    /**
     * 发送事件
     * @param type  类型
     * @param param 参数
     */
    public Post<T>(type: SandboxPosterEvent, param?: T): void {
        const list = this.listeners[type];
        if (!_.isArray(list)) {
            this.OnInitedPost[type] = param;
            return;
        }
        list.forEach((o) => o(param));
    }
}

const Poster = new SandboxPoster();

export default Poster as SandboxPoster;
